module.exports = __webpack_public_path__ + "static/media/homeOtherBg.58ee2975.png";